import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-otp-invalidate',
  templateUrl: './otp-invalidate.component.html',
  styleUrls: ['./otp-invalidate.component.scss']
})
export class OtpInvalidateComponent implements OnInit {

  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {
  }

  login() {
    this.router.navigate(['login']);
  }
}
